import React, { Component } from "react";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            width: "100%",
            textAlign: "center",
            background: "#f5f5f5",
            color: "#111",
            padding: "20px",
          }}
        >
          <DotLottieReact
            src="https://lottie.host/f847ceef-f89e-496a-8ff0-6d37c628e49f/HZcI87xNHp.lottie"
            loop
            autoplay
          />
          <p>Please refresh or go back to home.</p>
          <a href="/" style={{ textDecoration: "underline" }}>Go Home</a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;